/* eslint-disable vue/component-definition-name-casing */
import Vue from 'vue'
import App from './App.vue'
import VueCustomElement from 'vue-custom-element'
import './assets/base.scss'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false
Vue.use(VueCustomElement)
Vue.use(VueGoogleMaps)
Vue.customElement('pce-buynowb2c', App)